import React, { createContext, useContext, useSyncExternalStore } from 'react';
import { getDateTimePreferences, getDateTimeRevision, resolveDateTimeSettings, subscribeDateTimePreferences } from './dateTimeFormatting';

const DateTimeContext = createContext<ReturnType<typeof resolveDateTimeSettings> | null>(null);

export function DateTimeProvider({ children }: { children: React.ReactNode }) {
  useSyncExternalStore(subscribeDateTimePreferences, getDateTimeRevision, getDateTimeRevision);
  return <DateTimeContext.Provider value={resolveDateTimeSettings(getDateTimePreferences())}>{children}</DateTimeContext.Provider>;
}

export function useDateTimePreferences() {
  useSyncExternalStore(subscribeDateTimePreferences, getDateTimeRevision, getDateTimeRevision);
  return useContext(DateTimeContext) || resolveDateTimeSettings(getDateTimePreferences());
}